<template>
  <div class="real-verify-rules">
    <div class="custom-nav-block" :style="`paddingTop:${barHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="goBack">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.png" alt="" />
        </template>
      </van-nav-bar>
    </div>

    <div class="main">
      <section class="block">
        <h2 class="section-title">Positive example</h2>
        <ul class="rule-list">
          <li v-for="(text, i) in positiveRules" :key="'p' + i" class="rule-row">
            <img class="rule-icon rule-icon--ok" :src="icons.ok" alt="" />
            <span class="rule-text">{{ text }}</span>
          </li>
        </ul>
        <div class="thumbs">
          <div v-for="(src, i) in positiveThumbs" :key="'pt' + i" class="thumb-wrap">
            <div class="thumb">
              <img :src="src" alt="" class="thumb-img" />
            </div>
            <div class="badge badge--ok">
              <img :src="icons.ok" alt="" />
            </div>
          </div>
        </div>
      </section>

      <section class="block block--second">
        <h2 class="section-title">Negative example</h2>
        <ul class="rule-list">
          <li v-for="(text, i) in negativeRules" :key="'n' + i" class="rule-row">
            <img class="rule-icon rule-icon--bad" :src="icons.notOk" alt="" />
            <span class="rule-text">{{ text }}</span>
          </li>
        </ul>
        <div class="thumbs">
          <div v-for="(src, i) in negativePhotos" :key="'nt' + i" class="thumb-wrap">
            <div class="thumb">
              <img :src="src" alt="" class="thumb-img" />
            </div>
            <div class="badge badge--bad">
              <img :src="icons.notOk" alt="" />
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RealVerifyRules',
  data() {
    return {
      icons: {
        notOk: require('@/assets/packageAssets/views/P4_Page/RealVerifyRules/default/not-ok.png'),
        ok: require('@/assets/packageAssets/views/P4_Page/RealVerifyRules/default/ok.png')
      },
      positiveThumbs: [
        require('@/assets/packageAssets/views/P4_Page/RealVerifyRules/default/male-1.png'),
        require('@/assets/packageAssets/views/P4_Page/RealVerifyRules/default/male-2.png'),
        require('@/assets/packageAssets/views/P4_Page/RealVerifyRules/default/male-3.png')
      ],
      negativePhotos: [
        require('@/assets/packageAssets/views/P4_Page/RealVerifyRules/default/male-4.png'),
        require('@/assets/packageAssets/views/P4_Page/RealVerifyRules/default/male-5.png'),
        require('@/assets/packageAssets/views/P4_Page/RealVerifyRules/default/male-6.png')
      ],
      // prettier-ignore
      positiveRules: [
        'Facial photo of your own',
        'Upper body photo with proper dressing',
        'Smile and eyes to the front'
      ],
      // prettier-ignore
      negativeRules: [
        'Pornography and sexual innuendo',
        'Phone number or personal information',
        'Violence or politics'
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.real-verify-rules {
  min-height: 100vh;
  background: #f9f9fb;
}

.custom-nav-block {
  background-color: #f9f9fb;
}

.main {
  padding: 16px 16px 32px;
}

.block {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.block--second {
  margin-top: 64px;
}

.section-title {
  margin: 0 0 16px;
  width: 100%;
  max-width: 267px;
  color: #333;
  text-align: center;
  font-family: 'RobotoFlex-Regular';
  font-size: 17px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.rule-list {
  margin: 0 0 16px;
  padding: 0;
  list-style: none;
  width: 100%;
  max-width: 267px;
}

.rule-row {
  display: flex;
  align-items: flex-start;
  gap: 2px;
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }
}

.rule-icon {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  margin: 2px;
  box-sizing: border-box;
  position: relative;

  &--ok {
    display: block;
    width: 16px;
    height: 16px;
    margin: 2px;
  }

  &--bad {
    display: block;
    width: 16px;
    height: 16px;
    margin: 2px;
  }
}

.rule-text {
  flex: 1;
  max-width: 245px;
  color: #333;
  font-family: 'Roboto Flex';
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.thumbs {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 9px;
  width: 100%;
  max-width: 267px;
}

.thumb-wrap {
  position: relative;
  width: 83px;
  height: 110px;
  flex-shrink: 0;
}

.thumb {
  width: 83px;
  height: 110px;
  border-radius: 6px;
  overflow: hidden;
  background: #eee;
}

.thumb-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.badge {
  position: absolute;
  right: 4px;
  bottom: 4px;
  width: 24px;
  height: 24px;

  &--ok img,
  &--bad img {
    width: 24px;
    height: 24px;
    display: block;
  }
}
</style>
